import { Alert, Button } from 'easyship-components';
import { FormattedMessage } from 'react-intl';

import { usePaymentIntentContext } from '@/providers/PaymentIntentProvider/context';

export const ContinueToPaymentButton = () => {
  const { continueToPayment, isContinuingToPayment, continueToPaymentError } =
    usePaymentIntentContext();

  return (
    <div className="flex flex-col gap-2">
      {continueToPaymentError && <Alert severity="error">{continueToPaymentError}</Alert>}
      <Button
        className="w-full"
        color="primary"
        disabled={isContinuingToPayment}
        loading={isContinuingToPayment}
        onClick={continueToPayment}
      >
        <FormattedMessage id="credit-card.continue-to-payment" />
      </Button>
    </div>
  );
};
